// Crockford-style alphabet minus easily-confused glyphs (0/O, 1/I). 32 chars.
// 16 chars @ 32 alphabet ≈ 80 bits of entropy — ample collision resistance.
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

export function generateInviteToken(length = 16): string {
  const buf = new Uint8Array(length)
  crypto.getRandomValues(buf)
  let out = ''
  for (let i = 0; i < length; i++) out += ALPHABET[buf[i] % ALPHABET.length]
  return out
}
